import React from 'react';
import { Button } from '../../ui';

interface RoleFormProps {
  formData: {
    name: string;
    description: string;
  };
  errors: { [key: string]: string };
  isSubmitting: boolean;
  onFieldChange: (field: 'name' | 'description', value: string) => void;
  onSubmit: () => void;
}

const RoleForm: React.FC<RoleFormProps> = ({
  formData,
  errors,
  isSubmitting,
  onFieldChange,
  onSubmit
}) => {
  return (
    <div className="border rounded-lg p-4">
      <h3 className="font-semibold mb-4 text-lg">Crear Nuevo Rol de Usuarios</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre del Rol
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => onFieldChange('name', e.target.value)}
            className={`w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${
              errors.name ? 'border-red-500' : ''
            }`}
            placeholder="Ingrese el nombre del rol"
          />
          {errors.name && (
            <p className="mt-1 text-sm text-red-500">{errors.name}</p>
          )}
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Descripción
          </label>
          <textarea
            value={formData.description}
            onChange={(e) => onFieldChange('description', e.target.value)}
            className={`w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${
              errors.description ? 'border-red-500' : ''
            }`}
            placeholder="Ingrese la descripción del rol"
            rows={4}
          />
          {errors.description && (
            <p className="mt-1 text-sm text-red-500">{errors.description}</p>
          )}
        </div>
        
        <Button
          onClick={onSubmit}
          disabled={isSubmitting}
          variant="primary"
          fullWidth
          isLoading={isSubmitting}
        >
          {isSubmitting ? 'Creando...' : 'Crear Rol'}
        </Button>
      </div>
    </div>
  );
};

export default RoleForm;
